import { render } from "./EmptyCollection.vue?vue&type=template&id=296999a3"
import script from "./EmptyCollection.vue?vue&type=script&lang=js"
export * from "./EmptyCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
